import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendClientPortalChatMessage } from 'services/pod';
import { ISendMessagePayload } from 'services/pod/types';
import { IChatMessage } from 'components/ClientPortalChats/types';

interface IPayload extends ISendMessagePayload {
  messageId: number;
}

interface IResponse extends IChatMessage {
  messageId: number;
}

export const ThunkSendClientPortalChatMessage = createAsyncThunk<IResponse, IPayload>(
  'clientPortalChats/sendClientPortalChatMessage',
  async payload => {
    const r = await sendClientPortalChatMessage({
      message: payload.message,
      chatId: payload.chatId,
      resourceName: payload.resourceName,
    });
    return { ...r.data, messageId: payload.messageId };
  },
);
